import { useEffect } from 'react';
import { getShareConfig } from '@/http/api';
const wxJsSdk = async () => {
  return await import('weixin-js-sdk');
}
export default function useShare() {
  useEffect(() => {
    getShareConfig(location.href).
      then(async res =>{
        if(res.success){
          let config = res.data;
          const { appId, timestamp, nonceStr, signature } = config;
          const wx = await wxJsSdk();
          const shareInfo = {
            title: document.getElementsByTagName('meta')['shareTitle']?.content || '妙投-专业财经新闻热点资讯',
            link: document.getElementsByTagName('meta')['shareLink']?.content ?  document.getElementsByTagName('meta')['shareLink']?.content : location.href,
            imgUrl: document.getElementsByTagName('meta')['shareImgUrl']?.content || process.env.NEXT_PUBLIC_API_PRO + '/favicon.ico',
            desc: document.getElementsByTagName('meta')['shareDesc']?.content || '专注于新经济相关行业、投资标的分析解读，全方位拆解公司的基本面信息，为你提供客观详实的投资参考'
          }
          wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
            openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
          });
  
          wx.ready(function () {
            wx.updateTimelineShareData({ ...shareInfo });
            wx.updateAppMessageShareData({
              ...shareInfo,
              type: 'link',
              success: () => {},
            });
            wx.onMenuShareTimeline({ ...shareInfo });
            wx.onMenuShareAppMessage({
              ...shareInfo,
              type: 'link'
            });
          });
  
          wx.error(function (res) {
            console.error(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        }
      })
  }, []);

  return {};
}
